export const personalDataUsage = {
    title: 'Использование личных сведений',
    isBordered: true,
    blocks: [
        {
            type: 'text',
            value: 'Компания решает ряд задач, используя Ваши личные сведения от посещения нашего сайта, а именно:',
        },
        {
            type: 'list',
            items: [
                'предоставления услуг: обработка Вашего входящего сообщения, анализ запроса в сообщении, подбор и информирование ответственных специалистов Компании по теме сообщения, подготовка Вам исходящего сообщения или телефонного звонка, дальнейшая обратная связь;',
                'оперативного Вашего оповещения об обновлениях и изменениях при обсуждении возможного сотрудничества, а также информирования об обновлениях информации на сайте',
            ],
        },
    ],
};
